import React from "react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import WineCard from "../components/WineCard";
import SectionHeader from "../components/SectionHeader";
import { usePhotoOverrides } from "../lib/photos";
import { useWines } from "../lib/wines";

export default function Vina() {
  const photos = usePhotoOverrides();
  const wines = useWines();
  const imagesFor = (w) => [
    photos.first("wine", w.slug) && { ...photos.first("wine", w.slug), alt: w.alt_main || photos.first("wine", w.slug).alt || w.name },
    photos.first("wine-detail", w.slug) && { ...photos.first("wine-detail", w.slug), alt: w.alt_second || photos.first("wine-detail", w.slug).alt || w.name },
  ].filter(Boolean);
  return (
    <main id="main">
      <Seo path="/vina" title="Naše vína – nabídka lahví | Vinařství Brychta"
        description="Aktuální nabídka lahví Vinařství Brychta – Pálava, Müller Thurgau, Veltlínské zelené, Donauriesling, Hibernal a další. Objednávku potvrzujeme osobně." />
      <Breadcrumbs items={[{ label: "Naše vína" }]} />
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20">
        <SectionHeader as="h1" eyebrow="Naše vína" title="Lahve z rodinného vinařství"
          kicker="Vyberte, které lahve by vás zajímaly, a pošlete nám nezávaznou poptávku. Dostupnost, způsob převzetí a konečnou cenu potvrdíme osobně." />
        <div className="mt-4 text-xs text-charcoal/60 max-w-2xl">Nákup vína je určen osobám starším 18 let.</div>
        <h2 className="sr-only">Nabídka lahví</h2>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {wines.map((w) => <WineCard key={w.slug} wine={w} images={imagesFor(w)} />)}
        </div>
      </section>
    </main>
  );
}
